import React from "react";
import { useLanguage, T } from "@/lib/i18n";

export default function About() {
  const { lang } = useLanguage();
  const pillars = T.about.pillars[lang];

  return (
    <section id="about" data-testid="about-section" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-28 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-sjm-red">{T.about.eyebrow[lang]}</div>
            <h2 className={`mt-4 font-display font-extrabold tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-sjm-ink leading-tight ${lang === "bn" ? "font-bn" : ""}`}>
              {T.about.title[lang]}
            </h2>
          </div>
          <div className={`lg:col-span-8 space-y-5 text-base sm:text-lg text-sjm-muted leading-relaxed ${lang === "bn" ? "font-bn" : ""}`}>
            <p>{T.about.p1[lang]}</p>
            <p>{T.about.p2[lang]}</p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 border border-sjm-line">
          {pillars.map((p, i) => (
            <div key={i} className="p-8 border-b md:border-b-0 md:border-r last:border-0 border-sjm-line hover:bg-sjm-mist transition-colors">
              <div className="text-sjm-red font-display font-extrabold text-3xl">{p.k}</div>
              <div className={`mt-4 font-display font-bold text-2xl text-sjm-ink ${lang === "bn" ? "font-bn" : ""}`}>{p.t}</div>
              <p className={`mt-3 text-sjm-muted ${lang === "bn" ? "font-bn" : ""}`}>{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
